import { combineReducers } from 'redux'
import homeReducer from '../home'
import loginReducer from '../login'
import tokenReducer from '../token'
import googleAuthReducer from '../googleAuth'
import salaryReducer from '../salary'
import userReducer from '../user'
import transfersReducer from '../transfers'
import accountStatementReducer from '../accountsStatement'
import fastmenuReducer from '../fastmenu'
import dgkReducer from "../../actions/DGK"
import cardsStatementReducer from '../cardsStatement'
import {
  salaryCardReducer,
  excelSalaryCardReducer,
  trustedPersonReducers,
  bussinessCardListReducers,
  orderNumberReducers,
  orderSalaryCardReducers,
} from '../salaryCards'
import tableReducer from '../table'
import appConfigsReducer from '../configs'
import errorReducer from '../globalError/error.reducer'
import {
  AsanSignReducer,
  AsanVerifyReducer
} from '../ibsigning'
import { baseApi } from '@shared/api'
import orderDetailInfoReducer from '../salaryCards/orderDetailInfoReducers'
import employeePanReducer from '../limitsforBusinnesCard/employeePan'

export const rootReducer = combineReducers({
  home: homeReducer,
  login: loginReducer,
  token: tokenReducer,
  salary: salaryReducer,
  googleAuth: googleAuthReducer,
  user: userReducer,
  transfers: transfersReducer,
  accountsStatement: accountStatementReducer,
  cardsStatement: cardsStatementReducer,
  fastmenu: fastmenuReducer,
  salaryCard: salaryCardReducer,
  excelUploadSalaryCards: excelSalaryCardReducer,
  trustedPersonSalaryCards: trustedPersonReducers,
  bussinessCards: bussinessCardListReducers,
  orderNoInfo: orderNumberReducers,
  orderSalaryCard: orderSalaryCardReducers,
  table: tableReducer,
  appConfigs: appConfigsReducer,
  globalError: errorReducer,
  orderDetailInfo:orderDetailInfoReducer,
  ibSigningAsanSign: AsanSignReducer,
  ibSigningAsanVerify: AsanVerifyReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  employeePan: employeePanReducer,
  dgk: dgkReducer
});

export type RootState = ReturnType<typeof rootReducer>